import React from 'react';
import autoBind from 'react-autobind';
import ContentService from '../../services/ContentService.js';
import YourDetailsActions from './../../actions/YourDetailsActions.js';
import {YesNoRadioData, YesNoValues} from './../../constants/ApplicationConstants';
import RadioInput from '../Common/RadioInput.jsx';
import TextInput from '../Common/TextInput.jsx';

export default class AccountDesignation extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }
    
    handleUpdateOption(event) {
        YourDetailsActions.updateYourDetailsData(event.target.model, event.target.id, event.target.value, this.props.index);
    }

    render() {
        const optionModel = 'isAccountDesignation';
        const optionId = this.props.section + optionModel  + this.props.index;
        const content = ContentService.getContent().yourDetails;
        const accountDesignationHelpText = content.accountDesignationHelpText;
        const accountDesignationQuestion = content.accountDesignationQuestion;
        const accountDesignationOption = this.props.data.isAccountDesignation ? this.props.data.isAccountDesignation : YesNoValues.NO;

        const isNameInputHidden = accountDesignationOption !== YesNoValues.YES;
        const nameModel = 'accountDesignationName';
        const nameId = this.props.section + nameModel + this.props.index;
        const accountDesignationNameInput = content.accountDesignationNameInput;

        return (
            <div>
                <RadioInput id={optionId}
                    data={YesNoRadioData}
                    value={accountDesignationOption}
                    label={accountDesignationQuestion}
                    onChange={this.handleUpdateOption}
                    model={optionModel}
                    helpText={accountDesignationHelpText}
                    errorList={this.props.errorList} />  
                {isNameInputHidden 
                    ? null 
                    : <TextInput id={nameId}
                               label={accountDesignationNameInput}
                               value={this.props.data.accountDesignationName}
                               onBlur={this.handleUpdateOption}
                               model={nameModel}
                               mandatory={false}
                               errorList={this.props.errorList} />}
            </div>
        );
    }
}

AccountDesignation.propTypes = {
    index: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
    data: React.PropTypes.object.isRequired,
    section: React.PropTypes.string,
    errorList: React.PropTypes.array
};

AccountDesignation.defaultProps = {
    index: '',
    section: '',
    errorList: []
}




// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/AccountDesignation.jsx